import React from 'react';
import XlabsSlide from '../xlabs-page-elements/xlabs-images/xlabs-slides.png';


export default function XlabsLink() {
  return (
    <>
      <div className='w-full h-auto py-6 md:py-10 grid place-items-center'>
        <div className="space-y-4 grid place-items-center">
            <div className="text-[30px] font-monda font-bold tracking-tighter">Group project deck</div>
                <div className='w-[70%] md:w-72 md:h-48 rounded-md overflow-hidden drop-shadow-sm grid place-items-center'>
                  <img src={XlabsSlide} className='scale-[1]'/>
                </div>
            <a href="https://www.behance.net/gallery/143415511/X-Labs-x-Luminary-NFP-Youth-Audiences?fbclid=IwAR0flSbrhhZri420UqkpAnusOtlptgF_IB5kFw2Pzs3Yo1uA25brBw6ZktM&&"><button className='font-monda tracking-tight align-center w-fit px-4 py-2 mt-4 rounded-lg h-fit text-lg bg-lime-700 text-white font-bold  transition ease-in-out delay-2 hover:-translate-y-1 hover:scale-80 hover:bg-indigo-500 duration-300'>Process deck</button></a>
        </div>
      </div>
    </>
  )
}
